'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mightyFields = require('../../lib/mighty-fields');

var _utils = require('../../utils');

var _FieldSets = require('./main-contacts/FieldSets');

var _FieldSets2 = _interopRequireDefault(_FieldSets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;

var PlaintiffContactInfo = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(PlaintiffContactInfo, _Component);

  function PlaintiffContactInfo() {
    _classCallCheck(this, PlaintiffContactInfo);

    return _possibleConstructorReturn(this, (PlaintiffContactInfo.__proto__ || Object.getPrototypeOf(PlaintiffContactInfo)).apply(this, arguments));
  }

  _createClass(PlaintiffContactInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onPlaintiffInfoChanged = _props.onPlaintiffInfoChanged,
          plaintiff = _props.plaintiff;


      return _react2.default.createElement(_mightyFields.EditableCard, {
        fieldSets: this.fieldSet,
        model: plaintiff,
        onSave: onPlaintiffInfoChanged,
        title: 'Plaintiff'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSet',
    get: function get() {
      var _this2 = this;

      return [[{
        field: 'fullname',
        readOnly: true,
        render: function render() {
          return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('name', 'fs-mask') },
            getNameOrDefault(_this2.props.plaintiff)
          );
        },
        showLabel: false
      }]].concat(_toConsumableArray(_FieldSets2.default));
    }
  }]);

  return PlaintiffContactInfo;
}(_react.Component), _class3.defaultProps = {
  plaintiff: null
}, _class3.propTypes = {
  onPlaintiffInfoChanged: _propTypes2.default.func.isRequired,
  plaintiff: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'fieldSet', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'fieldSet'), _class2.prototype)), _class2)) || _class) || _class;

var _default = PlaintiffContactInfo;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/PlaintiffContactInfo.js');
  reactHotLoader.register(PlaintiffContactInfo, 'PlaintiffContactInfo', '/app/src/components/page-case/PlaintiffContactInfo.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/PlaintiffContactInfo.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9QbGFpbnRpZmZDb250YWN0SW5mby5qcyJdLCJuYW1lcyI6WyJnZXROYW1lT3JEZWZhdWx0IiwiRm9ybWF0dGluZ1V0aWxzIiwiUGxhaW50aWZmQ29udGFjdEluZm8iLCJhdXRvQmluZE1ldGhvZHMiLCJvYnNlcnZlciIsInByb3BzIiwib25QbGFpbnRpZmZJbmZvQ2hhbmdlZCIsInBsYWludGlmZiIsImZpZWxkU2V0IiwiZmllbGQiLCJyZWFkT25seSIsInJlbmRlciIsInNob3dMYWJlbCIsIkZJRUxEX1NFVFNfUExBSU5USUZGIiwiQ29tcG9uZW50IiwiZGVmYXVsdFByb3BzIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwiZnVuYyIsImlzUmVxdWlyZWQiLCJvYmplY3QiLCJjb21wdXRlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUNBOzs7O0FBRUE7O0FBQ0E7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFUUEsZ0IsR0FBcUJDLHNCLENBQXJCRCxnQjs7SUFJRkUsb0IsT0FGTEMsZ0MsZUFDQUMsbUI7Ozs7Ozs7Ozs7OzZCQWVXO0FBQUEsbUJBQ3NDLEtBQUtDLEtBRDNDO0FBQUEsVUFDQUMsc0JBREEsVUFDQUEsc0JBREE7QUFBQSxVQUN3QkMsU0FEeEIsVUFDd0JBLFNBRHhCOzs7QUFHUixhQUNFLDhCQUFDLDBCQUFEO0FBQ0UsbUJBQVcsS0FBS0MsUUFEbEI7QUFFRSxlQUFPRCxTQUZUO0FBR0UsZ0JBQVFELHNCQUhWO0FBSUUsZUFBTTtBQUpSLFFBREY7QUFRRDs7Ozs7Ozs7Ozt3QkF2QmU7QUFBQTs7QUFDZCxjQUNFLENBQUM7QUFDQ0csZUFBTyxVQURSO0FBRUNDLGtCQUFVLElBRlg7QUFHQ0MsZ0JBQVE7QUFBQSxpQkFBTTtBQUFBO0FBQUEsY0FBSyxXQUFXLDBCQUFHLE1BQUgsRUFBVyxTQUFYLENBQWhCO0FBQXdDWCw2QkFBaUIsT0FBS0ssS0FBTCxDQUFXRSxTQUE1QjtBQUF4QyxXQUFOO0FBQUEsU0FIVDtBQUlDSyxtQkFBVztBQUpaLE9BQUQsQ0FERiw0QkFPS0MsbUJBUEw7QUFTRDs7OztFQVpnQ0MsZ0IsV0EyQjFCQyxZLEdBQWU7QUFDcEJSLGFBQVc7QUFEUyxDLFVBSWZTLFMsR0FBWTtBQUNqQlYsMEJBQXdCVyxvQkFBVUMsSUFBVixDQUFlQyxVQUR0QjtBQUVqQlosYUFBV1Usb0JBQVVHO0FBRkosQyxxRUE5QmxCQyxjOztlQW9DWW5CLG9COzs7Ozs7Ozs7OzswQkF6Q1BGLGdCOzBCQUlGRSxvQiIsImZpbGUiOiJQbGFpbnRpZmZDb250YWN0SW5mby5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnO1xuaW1wb3J0IHsgY29tcHV0ZWQgfSBmcm9tICdtb2J4JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcblxuaW1wb3J0IHsgRWRpdGFibGVDYXJkIH0gZnJvbSAnLi4vLi4vbGliL21pZ2h0eS1maWVsZHMnO1xuaW1wb3J0IHsgRm9ybWF0dGluZ1V0aWxzIH0gZnJvbSAnLi4vLi4vdXRpbHMnO1xuXG5pbXBvcnQgRklFTERfU0VUU19QTEFJTlRJRkYgZnJvbSAnLi9tYWluLWNvbnRhY3RzL0ZpZWxkU2V0cyc7XG5cbmNvbnN0IHsgZ2V0TmFtZU9yRGVmYXVsdCB9ID0gRm9ybWF0dGluZ1V0aWxzO1xuXG5AYXV0b0JpbmRNZXRob2RzXG5Ab2JzZXJ2ZXJcbmNsYXNzIFBsYWludGlmZkNvbnRhY3RJbmZvIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgQGNvbXB1dGVkXG4gIGdldCBmaWVsZFNldCAoKSB7XG4gICAgcmV0dXJuIFtcbiAgICAgIFt7XG4gICAgICAgIGZpZWxkOiAnZnVsbG5hbWUnLFxuICAgICAgICByZWFkT25seTogdHJ1ZSxcbiAgICAgICAgcmVuZGVyOiAoKSA9PiA8ZGl2IGNsYXNzTmFtZT17Y3goJ25hbWUnLCAnZnMtbWFzaycpfT57Z2V0TmFtZU9yRGVmYXVsdCh0aGlzLnByb3BzLnBsYWludGlmZil9PC9kaXY+LFxuICAgICAgICBzaG93TGFiZWw6IGZhbHNlLFxuICAgICAgfV0sXG4gICAgICAuLi5GSUVMRF9TRVRTX1BMQUlOVElGRixcbiAgICBdO1xuICB9XG5cbiAgcmVuZGVyICgpIHtcbiAgICBjb25zdCB7IG9uUGxhaW50aWZmSW5mb0NoYW5nZWQsIHBsYWludGlmZiB9ID0gdGhpcy5wcm9wcztcblxuICAgIHJldHVybiAoXG4gICAgICA8RWRpdGFibGVDYXJkXG4gICAgICAgIGZpZWxkU2V0cz17dGhpcy5maWVsZFNldH1cbiAgICAgICAgbW9kZWw9e3BsYWludGlmZn1cbiAgICAgICAgb25TYXZlPXtvblBsYWludGlmZkluZm9DaGFuZ2VkfVxuICAgICAgICB0aXRsZT0nUGxhaW50aWZmJ1xuICAgICAgLz5cbiAgICApO1xuICB9XG5cbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBwbGFpbnRpZmY6IG51bGwsXG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIG9uUGxhaW50aWZmSW5mb0NoYW5nZWQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gICAgcGxhaW50aWZmOiBQcm9wVHlwZXMub2JqZWN0LFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IFBsYWludGlmZkNvbnRhY3RJbmZvO1xuIl19